import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { TableBase, TableKpiProviders } from "./categoryChartData.types";
import _ from "lodash";
import { getKpisForProvidersWithCategoryChart } from "../opendata";
import { EMPTY_ARRAY } from "../misc";
import { KpiReport } from "../processors";
import { getWaterSupplyTableData } from "./fetchWaterSupplyDemandTable";

export const fetchWaterSupplyDemandTableComparisonData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<TableKpiProviders> => {
    if (!providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0) return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, providers, false, categoryChart);

    const latestYear = _.orderBy(
        kpiReportResults?.map(d => d.year),
        d => d,
        "desc"
    )?.[0];

    if (latestYear == null) return null;

    const results = kpiReportResults?.filter(d => d.year === latestYear) ?? (EMPTY_ARRAY as KpiReport[]);

    const kpiCodeToResults = _.keyBy(results, d => d.kpiCode);

    const sKpis =
        kpis?.filter(kpi => kpi[0] != null && kpi[2] != null && kpiCodeToResults?.[kpi[0]]) ??
        (EMPTY_ARRAY as string[][]);

    // strict: true, use the exact kpis to make columns the same across
    const vis = providers.map(provider => {
        const _results = results.filter(d => d?.provider?.tid === provider?.tid);
        const { data, columns, rowClassNames } = getWaterSupplyTableData(sKpis, _results, true);
        return {
            categoryName: category?.name,
            type: "supply-demand",

            data: {
                enabledDownload: false,
                data,
                columns,
                rowClassNames,
                className: "supply-planning-table",
                pageSize: data?.length
            },
            waterProvider: provider,
            year: latestYear
        } as TableBase;
    });

    return {
        vis
    };
};
